import { __extends } from "tslib";
import { BitmapFilter } from './BitmapFilter';
import { somewhatImplemented, release } from '@awayfl/swf-loader';
import { axCoerceString } from '@awayfl/avm2';
var DisplacementMapFilter = /** @class */ (function (_super) {
    __extends(DisplacementMapFilter, _super);
    function DisplacementMapFilter(mapBitmap, mapPoint, componentX, componentY, scaleX, scaleY, mode, color, alpha) {
        if (mapBitmap === void 0) { mapBitmap = null; }
        if (mapPoint === void 0) { mapPoint = null; }
        if (componentX === void 0) { componentX = 0; }
        if (componentY === void 0) { componentY = 0; }
        if (scaleX === void 0) { scaleX = 0; }
        if (scaleY === void 0) { scaleY = 0; }
        if (mode === void 0) { mode = 'wrap'; }
        if (color === void 0) { color = 0; }
        if (alpha === void 0) { alpha = 0; }
        var _this = _super.call(this) || this;
        _this.mapBitmap = mapBitmap;
        _this.mapPoint = mapPoint;
        _this.componentX = componentX;
        _this.componentY = componentY;
        _this.scaleX = scaleX;
        _this.scaleY = scaleY;
        _this.mode = mode;
        _this.color = color;
        _this.alpha = alpha;
        return _this;
    }
    DisplacementMapFilter.FromUntyped = function (obj, sec) {
        return new sec.flash.filters.DisplacementMapFilter(obj.mapBitmap, obj.mapPoint, obj.componentX, obj.componentY, obj.scaleX, obj.scaleY, obj.mode, obj.color, obj.alpha);
    };
    Object.defineProperty(DisplacementMapFilter.prototype, "mapBitmap", {
        get: function () {
            release || somewhatImplemented('public flash.filters.DisplacementMapFilter::get mapBitmap');
            return this._mapBitmap;
        },
        set: function (value) {
            release || somewhatImplemented('public flash.filters.DisplacementMapFilter::set mapBitmap');
            this._mapBitmap = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplacementMapFilter.prototype, "mapPoint", {
        get: function () {
            release || somewhatImplemented('public flash.filters.DisplacementMapFilter::get mapPoint');
            return this._mapPoint;
        },
        set: function (value) {
            release || somewhatImplemented('public flash.filters.DisplacementMapFilter::set mapPoint');
            this._mapPoint = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplacementMapFilter.prototype, "componentX", {
        get: function () {
            return this._componentX;
        },
        set: function (value /*uint*/) {
            release || somewhatImplemented('public flash.filters.DisplacementMapFilter::set componentX');
            this._componentX = value >>> 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplacementMapFilter.prototype, "componentY", {
        get: function () {
            return this._componentY;
        },
        set: function (value /*uint*/) {
            release || somewhatImplemented('public flash.filters.DisplacementMapFilter::set componentY');
            this._componentY = value >>> 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplacementMapFilter.prototype, "scaleX", {
        get: function () {
            return this._scaleX;
        },
        set: function (value) {
            release || somewhatImplemented('public flash.filters.DisplacementMapFilter::set scaleX');
            this._scaleX = +value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplacementMapFilter.prototype, "scaleY", {
        get: function () {
            return this._scaleY;
        },
        set: function (value) {
            release || somewhatImplemented('public flash.filters.DisplacementMapFilter::set scaleY');
            this._scaleY = +value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplacementMapFilter.prototype, "mode", {
        get: function () {
            return this._mode;
        },
        set: function (value) {
            release || somewhatImplemented('public flash.filters.DisplacementMapFilter::set mode');
            this._mode = axCoerceString(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplacementMapFilter.prototype, "color", {
        get: function () {
            return this._color;
        },
        set: function (value /*uint*/) {
            release || somewhatImplemented('public flash.filters.DisplacementMapFilter::set color');
            this._color = (value >>> 0) & 0xffffff;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplacementMapFilter.prototype, "alpha", {
        get: function () {
            return this._alpha;
        },
        set: function (value) {
            release || somewhatImplemented('public flash.filters.DisplacementMapFilter::set alpha');
            this._alpha = +value;
        },
        enumerable: false,
        configurable: true
    });
    DisplacementMapFilter.prototype.clone = function () {
        return new this.sec.flash.filters.DisplacementMapFilter(this._mapBitmap, this._mapPoint, this._componentX, this._componentY, this._scaleX, this._scaleY, this._mode, this._color, this._alpha);
    };
    DisplacementMapFilter.prototype.toAwayObject = function () {
        return {
            filterName: 'displacement',
            mapBitmap: this._mapBitmap.adaptee,
            mapPoint: this._mapPoint.adaptee,
            componentX: this._componentX,
            componentY: this._componentY,
            scaleX: this._scaleX,
            scaleY: this._scaleY,
            mode: this._mode,
            color: this._color,
            alpha: this._alpha
        };
    };
    // Called whenever the class is initialized.
    DisplacementMapFilter.classInitializer = null;
    // List of static symbols to link.
    DisplacementMapFilter.classSymbols = null; // [];
    // List of instance symbols to link.
    DisplacementMapFilter.instanceSymbols = null;
    return DisplacementMapFilter;
}(BitmapFilter));
export { DisplacementMapFilter };
